export default __webpack_public_path__ + "static/media/025-graphic designer.98d28069.svg";